import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import CustomsClearance from "./CustomsClearance";
import { NavLink } from 'react-router-dom';

export default class CustomsClearances extends Base {
    constructor(props) {
        super(props);
        this.state = {
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: 'customsclearance',
            data: null,
            loading: true,
            filters: {
                carrierName: '',
                orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId
            },
            systemModuleId: 41,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            sort: '',
            menuId: 212,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CustomsClearance Caller={this} Id={id} OrderingId={this.state.filters.orderingId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CustomsClearance Caller={this} OrderingId={this.state.filters.orderingId} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {this.state.inline === false && <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست ترخیص ها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} ترخیص یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت ترخیص جدید</span>
                                            </a>
                                        </li>
                                        {this.state.inline === false && <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="شماره ترخیص" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.carrierName} onChange={e => this.state.filters.factorNumber = e.target.value} placeholder="نام شرکت" className="form-control" />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ ترخیصی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">طرف مقابل</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">گمرک ورودی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">گمرک محل ارزیابی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                            <div className="nk-tb-col text-end">عملیات</div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item "}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.number}
                                                        </a>
                                                    </span>
                                                </div>
												<div className="nk-tb-col">
                                                    <span className="onlyMobile">طرف مقابل: </span>
                                                    <span className="sub-text text-center">{record.clearanceCompanyName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">گمرک ورودی: </span>
                                                    <span className="sub-text text-center">{record.enterCustomName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">گمرک محل ارزیابی: </span>
                                                    <span className="sub-text text-center">{record.calculatorCustomName}</span>
                                                </div>                                                
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ: </span>
                                                    <span className="sub-text text-center">{this.money(record.totalCost)}</span>
                                                </div>                                               
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <em className="icon ni ni-pen"></em>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline === false && <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

            ];
        return contents;
    }
}